module.exports = __webpack_public_path__ + "static/media/N30.6add42ab.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N30.svg
// module id = 191
// module chunks = 0